import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type {WaypointNode} from '~/models/journey/waypoints'
import type {Path} from '~/types/util'

export default class IsNewToMedicareEnabledNode extends DecisionNodeBase {
    getNext(): WaypointNode | Path | null {
        const {flag} = FeatureFlags.use()
        const IsNewToMedicareEnabledNode = computed(() => flag<boolean>('new-to-medicare-flow').value)

        return this.yesNo(IsNewToMedicareEnabledNode.value)
    }

}